module.exports = __webpack_public_path__ + "static/img_0162_dpp_optimized-e96a39473619d7be7d66aa77119dcd69.jpg";